/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  // Add custom code below this line

  // Discount Code Functionality - Advanced AJAX Version
  console.log("[DISCOUNT] Advanced script loading...");

  class DiscountCode {
    constructor(container) {
      this.container = container;
      this.input = container.querySelector('[id^="discount-code-input"]');
      this.button = container.querySelector('[id^="apply-discount-button"]');
      this.message = container.querySelector('[id^="discount-message"]');
      this.isDrawer =
        container.closest(".cart__drawer-form") !== null ||
        container.closest("cart-drawer") !== null ||
        container.closest(".drawer") !== null;

      console.log("[DISCOUNT] Script loaded for container:", container);
      console.log("[DISCOUNT] Is drawer:", this.isDrawer);
      this.init();
    }

    init() {
      if (this.button && this.input) {
        console.log("[DISCOUNT] Button and input found");
        this.button.addEventListener("click", this.applyDiscount.bind(this));

        // Allow applying discount with Enter key
        this.input.addEventListener("keypress", (e) => {
          if (e.key === "Enter") {
            this.applyDiscount();
          }
        });
      } else {
        console.warn("[DISCOUNT] Button or input not found");
      }
    }

    formatMoney(cents) {
      // Format money according to Turkish format
      const amount = (cents / 100).toFixed(2);
      const parts = amount.split(".");
      const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return integerPart + "," + parts[1] + " TL";
    }

    updateCartUI(cart) {
      console.log("[DISCOUNT] Updating cart UI...", cart);

      // Update subtotal with discount info (without changing the main price)
      const subtotalElement =
        document.querySelector("[data-subtotal]") ||
        document.querySelector(".totals__subtotal-value") ||
        document.querySelector(".cart__price__subtotal");
      console.log("[DISCOUNT] Subtotal element found:", subtotalElement);

      // Update discounts section - try multiple selectors for drawer vs cart page
      const discountsElement =
        document.querySelector("[data-discounts]") ||
        document.querySelector(".cart__total__discount") ||
        document.querySelector(".discounts") ||
        document.querySelector(".cart__discounts");

      console.log("[DISCOUNT] Discounts element found:", discountsElement);

      if (discountsElement) {
        if (
          cart.cart_level_discount_applications &&
          cart.cart_level_discount_applications.length > 0
        ) {
          const discountsHTML = cart.cart_level_discount_applications
            .map((discount) => {
              const discountAmount = this.formatMoney(
                discount.total_allocated_amount
              );

              // Different HTML structure for drawer vs cart page
              if (this.isDrawer) {
                return `
                <div class="cart__total cart__discount-item">
                  <div class="cart__discount-label">
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tags" viewBox="0 0 25 26">
                      <g stroke="#000" stroke-width=".875">
                        <path d="M4.304.79h8.571l12 11.835M9.594 4.17H2.589c-.946 0-1.714.758-1.714 1.692v6.907c0 .449.18.88.502 1.196l10.47 10.329c.67.66 1.755.66 2.423 0 .173-.17.308-.376.394-.602l1.64-4.304 4.364-1.615a1.684 1.684 0 0 0 .61-2.779L10.805 4.666a1.725 1.725 0 0 0-1.211-.495Z"></path>
                        <path d="M6.018 8.82a.426.426 0 0 0-.429.423c0 .234.192.423.429.423.236 0 .428-.19.428-.423a.424.424 0 0 0-.426-.422h-.002"></path>
                      </g>
                    </svg>
                    <span>${discount.title}</span>
                  </div>
                  <span class="cart__discount-amount">-${discountAmount}</span>
                </div>
              `;
              } else {
                return `
                <li class="discounts__discount discounts__discount--end">
                  <svg aria-hidden="true" focusable="false" viewBox="0 0 12 12" class="icon icon-discount color-foreground-75">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="m7 1 3 3-6 6-3-3 6-6Z"></path>
                  </svg>
                  ${discount.title} (-${discountAmount})
                </li>
              `;
              }
            })
            .join("");
          discountsElement.innerHTML = discountsHTML;

          // Show the discount section
          discountsElement.classList.remove("hidden");
          if (discountsElement.parentElement) {
            discountsElement.parentElement.classList.remove("hidden");
          }
        } else {
          discountsElement.innerHTML = "";
          discountsElement.classList.add("hidden");
        }
      }

      // Add discount savings info above/below subtotal - more prominent for drawer
      if (
        cart.cart_level_discount_applications &&
        cart.cart_level_discount_applications.length > 0
      ) {
        const totalDiscountAmount =
          cart.cart_level_discount_applications.reduce((sum, discount) => {
            return sum + discount.total_allocated_amount;
          }, 0);

        const savingsText = `Indirimden kazancınız: ${this.formatMoney(
          totalDiscountAmount
        )}`;

        // Remove existing savings info
        const existingSavings = document.querySelectorAll(
          ".discount-savings-info"
        );
        existingSavings.forEach((el) => el.remove());

        // Add new savings info
        const savingsDiv = document.createElement("div");
        savingsDiv.className = this.isDrawer
          ? "discount-savings-info discount-savings-info--drawer"
          : "discount-savings-info discount-savings-info--page";

        savingsDiv.textContent = savingsText;

        // Insert savings info in appropriate location
        if (subtotalElement && subtotalElement.parentNode) {
          if (this.isDrawer) {
            // In drawer, add it prominently after the subtotal section
            const cartPriceHolder = subtotalElement.closest(
              ".cart__price__holder"
            );
            if (cartPriceHolder) {
              cartPriceHolder.appendChild(savingsDiv);
            } else {
              subtotalElement.parentNode.appendChild(savingsDiv);
            }
          } else {
            subtotalElement.parentNode.appendChild(savingsDiv);
          }
        }
      }

      // Update cart count if available
      const cartCountElements = document.querySelectorAll("[data-cart-count]");
      cartCountElements.forEach((el) => {
        el.textContent = cart.item_count;
      });

      // Clear input
      this.input.value = "";
    }

    applyDiscount() {
      const code = this.input.value.trim();
      console.log("[DISCOUNT] Apply clicked with code:", code);

      if (!code) {
        this.message.textContent = "Please enter a discount code.";
        this.message.style.color = "#f05832";
        return;
      }

      this.button.disabled = true;
      this.button.textContent = "Applying...";
      this.message.textContent = "Applying discount...";
      this.message.style.color = "#333";

      // First check if discount is already applied
      fetch("/cart.js")
        .then((res) => res.json())
        .then((currentCart) => {
          console.log("[DISCOUNT] Current cart:", currentCart);

          // Check if this exact discount code is already applied
          const existingDiscounts =
            currentCart.cart_level_discount_applications || [];
          const isDuplicateDiscount = existingDiscounts.some((discount) => {
            // More precise matching - check if the discount title exactly matches or ends with the code
            const discountTitle = discount.title.toLowerCase();
            const inputCode = code.toLowerCase();
            return (
              discountTitle === inputCode ||
              discountTitle.endsWith(` ${inputCode}`) ||
              discountTitle.startsWith(`${inputCode} `)
            );
          });

          console.log("[DISCOUNT] Existing discounts:", existingDiscounts);
          console.log("[DISCOUNT] Is duplicate?", isDuplicateDiscount);

          if (isDuplicateDiscount) {
            this.message.textContent = `Discount "${code}" is already applied to your cart.`;
            this.message.style.color = "#f05832";
            this.button.disabled = false;
            this.button.textContent = "Apply";
            return Promise.reject("duplicate"); // Stop the chain
          }

          // Proceed with applying the discount
          return fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ discount: code }),
          });
        })
        .then((updateResponse) => {
          console.log(
            "[DISCOUNT] Update response status:",
            updateResponse.status
          );
          console.log("[DISCOUNT] Update response ok:", updateResponse.ok);
          return updateResponse.json().catch(() => ({})); // Handle empty response
        })
        .then((updateResult) => {
          console.log("[DISCOUNT] Update result:", updateResult);
          // Wait a bit then fetch cart
          return new Promise((resolve) => setTimeout(resolve, 300)).then(() =>
            fetch("/cart.js")
          );
        })
        .then((res) => res.json())
        .then((cart) => {
          console.log("[DISCOUNT] Full cart response:", cart);

          // Check multiple possible discount properties
          const cartLevelDiscounts =
            cart.cart_level_discount_applications || [];
          const totalDiscounts = cart.total_discount || 0;
          const discounts = cart.discounts || [];

          console.log("[DISCOUNT] Cart level discounts:", cartLevelDiscounts);
          console.log("[DISCOUNT] Total discount amount:", totalDiscounts);
          console.log("[DISCOUNT] Discounts array:", discounts);

          // Check if any discount is applied
          const hasCartLevelDiscount = cartLevelDiscounts.length > 0;
          const hasTotalDiscount = totalDiscounts > 0;
          const hasDiscountsArray = discounts.length > 0;

          const applied =
            hasCartLevelDiscount || hasTotalDiscount || hasDiscountsArray;

          if (applied) {
            this.message.textContent = `Discount "${code}" applied successfully!`;
            this.message.style.color = "green";

            // Update UI without reloading
            this.updateCartUI(cart);

            // Only reload cart page, never redirect from drawer
            if (!this.isDrawer) {
              setTimeout(() => {
                location.reload();
              }, 1000);
            }
          } else {
            this.message.textContent = `Discount "${code}" is invalid or could not be applied.`;
            this.message.style.color = "red";
          }

          console.log("[DISCOUNT] Applied status:", applied);
        })
        .catch((err) => {
          if (err === "duplicate") {
            // Already handled above, don't show another error
            return;
          }
          this.message.textContent = "Failed to apply discount.";
          this.message.style.color = "red";
          console.error("[DISCOUNT] Error applying discount:", err);
        })
        .finally(() => {
          this.button.disabled = false;
          this.button.textContent = "Apply";
        });
    }
  }

  // Initialize discount code functionality when DOM is loaded
  document.addEventListener("DOMContentLoaded", () => {
    console.log("[DISCOUNT] DOM Content Loaded, initializing...");

    // Initialize for cart page
    const cartPageDiscount = document.querySelector(".cart__discount");
    if (cartPageDiscount && !cartPageDiscount.closest("cart-drawer")) {
      console.log("[DISCOUNT] Cart page discount found");
      new DiscountCode(cartPageDiscount);
    }

    // Initialize for cart drawer
    const drawerDiscount = document.querySelector(
      "cart-drawer .cart__discount"
    );
    if (drawerDiscount) {
      console.log("[DISCOUNT] Drawer discount found");
      new DiscountCode(drawerDiscount);
    }
  });

  // Also initialize when cart drawer is opened (for dynamic content)
  document.addEventListener("cart:drawer:open", () => {
    console.log("[DISCOUNT] Cart drawer opened");
    setTimeout(() => {
      const drawerDiscount = document.querySelector(
        "cart-drawer .cart__discount"
      );
      if (drawerDiscount && !drawerDiscount.hasDiscountCode) {
        drawerDiscount.hasDiscountCode = true;
        console.log("[DISCOUNT] Initializing drawer discount");
        new DiscountCode(drawerDiscount);
      }
    }, 100);
  });

  // Initialize when cart drawer content changes
  if (typeof window.CartDrawer !== "undefined") {
    const originalOpen = window.CartDrawer.open;
    window.CartDrawer.open = function () {
      originalOpen.apply(this, arguments);
      setTimeout(() => {
        const drawerDiscount = document.querySelector(
          "cart-drawer .cart__discount"
        );
        if (drawerDiscount && !drawerDiscount.hasDiscountCode) {
          drawerDiscount.hasDiscountCode = true;
          new DiscountCode(drawerDiscount);
        }
      }, 200);
    };
  }

  // MutationObserver to watch for cart drawer content changes
  const observeCartDrawer = () => {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      console.log("[DISCOUNT] Setting up MutationObserver for cart drawer");

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            // Check if discount code elements were added
            const drawerDiscount = cartDrawer.querySelector(".cart__discount");
            if (drawerDiscount && !drawerDiscount.hasDiscountCode) {
              console.log(
                "[DISCOUNT] New discount code element found in drawer"
              );
              drawerDiscount.hasDiscountCode = true;
              new DiscountCode(drawerDiscount);
            }
          }
        });
      });

      observer.observe(cartDrawer, {
        childList: true,
        subtree: true,
      });
    }
  };

  // Initialize observer when DOM is ready
  setTimeout(() => {
    observeCartDrawer();
  }, 1000);

  // Collection toolbar sort/display picker - tam kontrol (açma, kapatma, seçim)
  function initCollectionToolbarFix() {
    const sortBtn = document.querySelector('[data-action="open-value-picker"][aria-controls="sort-by-selector"]');
    const displayBtn = document.querySelector('[data-action="open-value-picker"][aria-controls="display-by-selector"]');

    function openPicker(btn, pickerId) {
      const picker = document.getElementById(pickerId);
      if (picker && picker.getAttribute('aria-hidden') === 'true') {
        btn.setAttribute('aria-expanded', 'true');
        picker.setAttribute('aria-hidden', 'false');
        document.body.classList.add('no-mobile-scroll');
      }
    }

    function closePicker(btn, pickerId) {
      const picker = document.getElementById(pickerId);
      if (picker && picker.getAttribute('aria-hidden') === 'false') {
        if (btn) btn.setAttribute('aria-expanded', 'false');
        picker.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('no-mobile-scroll');
      }
    }

    function handleSortSelect(value) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }

    function handleDisplaySelect(value) {
      fetch(window.routes.cartUrl + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ attributes: { collection_products_per_page: value } }),
        credentials: 'same-origin'
      }).then(function () {
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    // Document-level click handler - capture phase
    function handleDocumentClick(e) {
      const target = e.target.closest ? e.target : e.target.parentElement;

      // Sort/Display seçimi - önce kontrol et (seçim yapıldığında sayfa yenilenecek)
      const selectBtn = target && target.closest && target.closest('#sort-by-selector [data-action="select-value"], #display-by-selector [data-action="select-value"]');
      if (selectBtn) {
        const value = selectBtn.getAttribute('data-value');
        const picker = selectBtn.closest('.value-picker');
        if (picker && value) {
          if (picker.id === 'sort-by-selector') {
            handleSortSelect(value);
          } else if (picker.id === 'display-by-selector') {
            handleDisplaySelect(value);
          }
          e.preventDefault();
          e.stopPropagation();
        }
        return;
      }

      // Filtre butonu - mobilde drawer aç (sadece collection sayfasında)
      const filterBtn = target && target.closest && target.closest('.collection__toolbar [data-action="open-drawer"][aria-controls="mobile-collection-filters"]');
      if (filterBtn && window.innerWidth < 1000) {
        const drawer = document.getElementById('mobile-collection-filters');
        if (drawer && drawer.getAttribute('aria-hidden') === 'true') {
          filterBtn.setAttribute('aria-expanded', 'true');
          drawer.setAttribute('aria-hidden', 'false');
          document.body.classList.add('no-mobile-scroll');
          const collectionDrawer = drawer.querySelector('.collection-drawer');
          if (collectionDrawer) collectionDrawer.style.maxHeight = window.innerHeight + 'px';
        }
        return;
      }

      // Filtre drawer Sonuçları Görüntüle - mobilde filtreleri uygula ve sayfayı yenile
      const viewResultsBtn = target && target.closest && target.closest('.collection-drawer__footer [data-action="close-drawer"]');
      if (viewResultsBtn && window.innerWidth < 1000) {
        const form = document.getElementById('mobile-collection-filters-form');
        if (form) {
          const formData = new FormData(form);
          const searchParams = new URLSearchParams(formData).toString();
          const url = window.location.pathname + (searchParams ? '?' + searchParams : '');
          e.preventDefault();
          e.stopPropagation();
          window.location.href = url;
        }
        return;
      }

      // Aktif filtre X ve Hepsini temizle - mobilde çalışsın
      const clearFilterBtn = target && target.closest && target.closest('.collection__mobile-active-filters [data-action="clear-filters"], .collection__mobile-active-clear');
      if (clearFilterBtn && window.innerWidth < 1000) {
        const url = clearFilterBtn.getAttribute('data-url');
        if (url) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = url;
        }
        return;
      }

      // Desktop filtre X ve Hepsini temizle
      const desktopClearFilterBtn = target && target.closest && target.closest('#desktop-filters-form .collection__active-filter-item[data-url], #desktop-filters-form .collection__clear-filter');
      if (desktopClearFilterBtn && window.innerWidth >= 1000) {
        const url = desktopClearFilterBtn.getAttribute('data-url');
        if (url) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = url;
        }
        return;
      }

      // Filtre drawer X - mobilde sadece kapat
      const filterCloseBtn = target && target.closest && target.closest('#mobile-collection-filters [data-action="close-drawer"]');
      if (filterCloseBtn && window.innerWidth < 1000) {
        const drawer = document.getElementById('mobile-collection-filters');
        if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
          document.querySelector('[aria-controls="mobile-collection-filters"]')?.setAttribute('aria-expanded', 'false');
          drawer.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('no-mobile-scroll');
          e.preventDefault();
          e.stopPropagation();
        }
        return;
      }

      // Grid/List view değiştirme
      const layoutBtn = target && target.closest && target.closest('.collection__toolbar [data-action="change-layout"]');
      if (layoutBtn && !layoutBtn.classList.contains('is-selected')) {
        const newLayoutMode = layoutBtn.getAttribute('data-layout-mode');
        const section = document.querySelector('[data-section-type="collection"]');
        var gridClasses = '';
        if (section) {
          try {
            var settingsJson = section.getAttribute('data-section-settings');
            if (settingsJson) {
              var settings = JSON.parse(settingsJson);
              gridClasses = settings.gridClasses || '';
            }
          } catch (err) {
            gridClasses = '1/3--tablet 1/4--lap-and-up';
          }
        }

        fetch(window.routes.cartUrl + '/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ attributes: { collection_layout: newLayoutMode } }),
          credentials: 'same-origin'
        }).then(function () {
          var siblings = layoutBtn.parentElement.querySelectorAll('.collection__layout-button.is-selected');
          for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('is-selected');
          layoutBtn.classList.add('is-selected');

          var productItems = section ? section.querySelectorAll('.product-item') : [];
          for (var j = 0; j < productItems.length; j++) {
            if (newLayoutMode === 'grid') {
              productItems[j].className = 'product-item product-item--vertical ' + gridClasses;
            } else {
              productItems[j].className = 'product-item product-item--list';
            }
          }
        });
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      // X (close) butonuna tıklanınca kapat
      const sortCloseBtn = target && target.closest && target.closest('[data-action="close-value-picker"][aria-controls="sort-by-selector"]');
      const displayCloseBtn = target && target.closest && target.closest('[data-action="close-value-picker"][aria-controls="display-by-selector"]');
      if (sortCloseBtn) {
        const picker = document.getElementById('sort-by-selector');
        const openBtn = document.querySelector('[data-action="open-value-picker"][aria-controls="sort-by-selector"]');
        if (picker && picker.getAttribute('aria-hidden') === 'false') {
          closePicker(openBtn, 'sort-by-selector');
          e.preventDefault();
          e.stopPropagation();
        }
        return;
      }
      if (displayCloseBtn) {
        const picker = document.getElementById('display-by-selector');
        const openBtn = document.querySelector('[data-action="open-value-picker"][aria-controls="display-by-selector"]');
        if (picker && picker.getAttribute('aria-hidden') === 'false') {
          closePicker(openBtn, 'display-by-selector');
          e.preventDefault();
          e.stopPropagation();
        }
        return;
      }

      // Sadece arrow (toggle) butonuna tıklanınca kapat
      const sortToggleBtn = target && target.closest && target.closest('[data-action="open-value-picker"][aria-controls="sort-by-selector"]');
      const displayToggleBtn = target && target.closest && target.closest('[data-action="open-value-picker"][aria-controls="display-by-selector"]');
      if (sortToggleBtn) {
        const picker = document.getElementById('sort-by-selector');
        if (picker && picker.getAttribute('aria-hidden') === 'false') {
          closePicker(sortToggleBtn, 'sort-by-selector');
          e.preventDefault();
          e.stopPropagation();
        }
        return;
      }
      if (displayToggleBtn) {
        const picker = document.getElementById('display-by-selector');
        if (picker && picker.getAttribute('aria-hidden') === 'false') {
          closePicker(displayToggleBtn, 'display-by-selector');
          e.preventDefault();
          e.stopPropagation();
        }
        return;
      }
    }

    if (sortBtn && !sortBtn._collectionToolbarFix) {
      sortBtn._collectionToolbarFix = true;
      sortBtn.addEventListener('click', function () {
        const picker = document.getElementById('sort-by-selector');
        if (picker && picker.getAttribute('aria-hidden') === 'true') {
          openPicker(sortBtn, 'sort-by-selector');
        }
      }, true);
    }
    if (displayBtn && !displayBtn._collectionToolbarFix) {
      displayBtn._collectionToolbarFix = true;
      displayBtn.addEventListener('click', function () {
        const picker = document.getElementById('display-by-selector');
        if (picker && picker.getAttribute('aria-hidden') === 'true') {
          openPicker(displayBtn, 'display-by-selector');
        }
      }, true);
    }

    document.removeEventListener('click', handleDocumentClick, true);
    document.addEventListener('click', handleDocumentClick, true);

    // Desktop filtre seçildiğinde hemen uygula
    function handleDesktopFilterChange(e) {
      if (window.innerWidth < 1000) return;
      const input = e.target;
      const form = input && input.closest && input.closest('#desktop-filters-form');
      if (!form || !input.name || input.name === 'sort_by' || input.name === 'q') return;
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData).toString();
      const url = window.location.pathname + (searchParams ? '?' + searchParams : '');
      window.location.href = url;
    }
    document.removeEventListener('change', handleDesktopFilterChange);
    document.addEventListener('change', handleDesktopFilterChange);
  }

  document.addEventListener('DOMContentLoaded', initCollectionToolbarFix);
  document.addEventListener('shopify:section:load', initCollectionToolbarFix);

  // Auto-open cart drawer when product is added
  document.addEventListener("product:added", function (event) {
    console.log("[CART DRAWER] Product added event received:", event.detail);

    // Only auto-open if cart type is drawer
    if (window.theme && window.theme.cartType === "drawer") {
      // Check if CartDrawer is available and open it
      if (typeof window.CartDrawer !== "undefined" && window.CartDrawer.open) {
        console.log("[CART DRAWER] Opening cart drawer automatically");
        window.CartDrawer.open();
      } else {
        // Fallback: try to find and click the cart drawer trigger
        const cartDrawerTrigger = document.querySelector(
          '[aria-controls="mini-cart"]'
        );
        if (cartDrawerTrigger) {
          console.log("[CART DRAWER] Opening cart drawer via trigger click");
          cartDrawerTrigger.click();
        }
      }
    }
  });

  // Fix video auto-play issue when scrolling while paused
  document.addEventListener("DOMContentLoaded", function () {
    console.log("[VIDEO FIX] Initializing video pause fix...");

    // Store paused videos to prevent auto-play on scroll
    const pausedVideos = new Set();

    // Function to handle video pause state
    function handleVideoPause(event) {
      const video = event.target;
      if (video && video.tagName === "VIDEO") {
        console.log("[VIDEO FIX] Video paused, storing state");
        pausedVideos.add(video);
      }
    }

    // Function to handle video play state
    function handleVideoPlay(event) {
      const video = event.target;
      if (video && video.tagName === "VIDEO") {
        console.log("[VIDEO FIX] Video playing, removing from paused set");
        pausedVideos.delete(video);
      }
    }

    // Function to handle scroll events
    function handleScroll(event) {
      // Check if any paused videos are trying to auto-play
      pausedVideos.forEach((video) => {
        if (video && !video.paused) {
          console.log("[VIDEO FIX] Preventing auto-play for paused video");
          video.pause();
        }
      });

      // Also disable autoplay for paused videos
      disableAutoplayForPausedVideos();
    }

    // Function to disable autoplay for paused videos
    function disableAutoplayForPausedVideos() {
      pausedVideos.forEach((video) => {
        if (video) {
          video.autoplay = false;
          video.removeAttribute("autoplay");
          console.log("[VIDEO FIX] Disabled autoplay for paused video");
        }
      });
    }

    // Add event listeners to all videos
    function addVideoListeners() {
      const videos = document.querySelectorAll("video");
      videos.forEach((video) => {
        video.addEventListener("pause", handleVideoPause);
        video.addEventListener("play", handleVideoPlay);
        video.addEventListener("loadeddata", handleVideoPause); // Prevent auto-play on load
        video.addEventListener("canplay", handleVideoPause); // Prevent auto-play when ready
        console.log("[VIDEO FIX] Added listeners to video:", video);
      });
    }

    // Add scroll and resize listeners
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("wheel", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll, { passive: true });

    // Initial setup
    addVideoListeners();

    // Re-setup when new videos are added (for dynamic content)
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              // Element node
              const videos = node.querySelectorAll
                ? node.querySelectorAll("video")
                : [];
              videos.forEach((video) => {
                video.addEventListener("pause", handleVideoPause);
                video.addEventListener("play", handleVideoPlay);
                video.addEventListener("loadeddata", handleVideoPause); // Prevent auto-play on load
                video.addEventListener("canplay", handleVideoPause); // Prevent auto-play when ready
                console.log("[VIDEO FIX] Added listeners to new video:", video);
              });
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    console.log("[VIDEO FIX] Video pause fix initialized successfully");
  });

  // Price Info Popup Flickity Fix
  function initPriceInfoPopup() {
    const containers = document.querySelectorAll('.price-info-container');
    
    containers.forEach(container => {
      const icon = container.querySelector('.price-info-icon');
      const originalPopup = container.querySelector('.price-info-popup');
      
      if (!icon || !originalPopup) return;
      
      // Remove existing event listeners if they exist
      if (icon._mouseEnterHandler) {
        icon.removeEventListener('mouseenter', icon._mouseEnterHandler);
      }
      if (container._mouseLeaveHandler) {
        container.removeEventListener('mouseleave', container._mouseLeaveHandler);
      }
      if (icon._outsideClickHandler) {
        document.removeEventListener('touchstart', icon._outsideClickHandler);
      }
      
      // Hide original popup
      originalPopup.style.display = 'none';
      
      // Create popup clone for body
      const bodyPopup = originalPopup.cloneNode(true);
      bodyPopup.id = 'body-popup-' + Math.random().toString(36).substr(2, 9);
      bodyPopup.style.position = 'fixed';
      bodyPopup.style.zIndex = '1';
      bodyPopup.style.opacity = '0';
      bodyPopup.style.visibility = 'hidden';
      bodyPopup.style.pointerEvents = 'none';
      bodyPopup.style.display = 'block';
      bodyPopup.style.height = 'max-content';
      
      // Append to body
      document.body.appendChild(bodyPopup);
      
      // Create new handlers
      icon._mouseEnterHandler = function() {
        // Get icon position
        const iconRect = icon.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const popupWidth = 280;
        
        // Calculate space
        const spaceOnRight = viewportWidth - iconRect.left;
        const spaceOnLeft = iconRect.left;
        
        // Position popup above icon
        bodyPopup.style.top = (iconRect.top - 8) + 'px';
        
        // Smart positioning
        if (spaceOnRight >= popupWidth + 20) {
          bodyPopup.style.left = iconRect.left + 'px';
          bodyPopup.style.transform = 'translateY(-100%)';
        } else if (spaceOnLeft >= popupWidth + 20) {
          bodyPopup.style.left = (iconRect.right - popupWidth) + 'px';
          bodyPopup.style.transform = 'translateY(-100%)';
        } else {
          bodyPopup.style.left = (iconRect.left + iconRect.width / 2) + 'px';
          bodyPopup.style.transform = 'translate(-50%, -100%)';
        }
        
        bodyPopup.style.opacity = '1';
        bodyPopup.style.visibility = 'visible';
        bodyPopup.style.pointerEvents = 'auto';
      };
      
      container._mouseLeaveHandler = function() {
        bodyPopup.style.opacity = '0';
        bodyPopup.style.visibility = 'hidden';
        bodyPopup.style.pointerEvents = 'none';
      };
      
      // Mobile touch handler
      icon._touchHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Toggle popup on mobile
        if (bodyPopup.style.opacity === '1') {
          bodyPopup.style.opacity = '0';
          bodyPopup.style.visibility = 'hidden';
          bodyPopup.style.pointerEvents = 'none';
        } else {
          // Get icon position
          const iconRect = icon.getBoundingClientRect();
          const viewportWidth = window.innerWidth;
          const popupWidth = 280;
          
          // Calculate space
          const spaceOnRight = viewportWidth - iconRect.left;
          const spaceOnLeft = iconRect.left;
          
          // Position popup above icon
          bodyPopup.style.top = (iconRect.top - 8) + 'px';
          
          // Smart positioning
          if (spaceOnRight >= popupWidth + 20) {
            bodyPopup.style.left = iconRect.left + 'px';
            bodyPopup.style.transform = 'translateY(-100%)';
          } else if (spaceOnLeft >= popupWidth + 20) {
            bodyPopup.style.left = (iconRect.right - popupWidth) + 'px';
            bodyPopup.style.transform = 'translateY(-100%)';
          } else {
            bodyPopup.style.left = (iconRect.left + iconRect.width / 2) + 'px';
            bodyPopup.style.transform = 'translate(-50%, -100%)';
          }
          
          bodyPopup.style.opacity = '1';
          bodyPopup.style.visibility = 'visible';
          bodyPopup.style.pointerEvents = 'auto';
        }
      };
      
      // Close popup when clicking outside on mobile
      icon._outsideClickHandler = function(e) {
        if (bodyPopup.style.opacity === '1' && !container.contains(e.target) && !bodyPopup.contains(e.target)) {
          bodyPopup.style.opacity = '0';
          bodyPopup.style.visibility = 'hidden';
          bodyPopup.style.pointerEvents = 'none';
        }
      };
      
      // Add event listeners
      icon.addEventListener('mouseenter', icon._mouseEnterHandler);
      container.addEventListener('mouseleave', container._mouseLeaveHandler);
      icon.addEventListener('touchstart', icon._touchHandler);
      document.addEventListener('touchstart', icon._outsideClickHandler);
      
      // Close popup on scroll
      window.addEventListener('scroll', function() {
        if (bodyPopup.style.opacity === '1') {
          bodyPopup.style.opacity = '0';
          bodyPopup.style.visibility = 'hidden';
          bodyPopup.style.pointerEvents = 'none';
        }
      });
      
      // Store reference for cleanup
      container._bodyPopup = bodyPopup;
    });
  }
  
  // Cleanup function
  function cleanupPriceInfoPopup() {
    const bodyPopups = document.querySelectorAll('[id^="body-popup-"]');
    bodyPopups.forEach(popup => popup.remove());
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      cleanupPriceInfoPopup();
      initPriceInfoPopup();
    });
  } else {
    cleanupPriceInfoPopup();
    initPriceInfoPopup();
  }
  
  // Re-initialize when new content is added
  const popupObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList.contains('price-info-container') || node.querySelector('.price-info-container'))) {
            cleanupPriceInfoPopup();
            initPriceInfoPopup();
          }
        });
      }
    });
  });
  
  popupObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Cart page: require three agreements to enable checkout button
  document.addEventListener('DOMContentLoaded', function () {
    const checkbox1 = document.getElementById('agreementCheckbox1');
    const checkbox2 = document.getElementById('agreementCheckbox2');
    const checkbox3 = document.getElementById('agreementCheckbox3');
    const submitButton = document.getElementById('submitButton');

    // Only run cart logic if we have all 3 checkboxes (cart page)
    if (checkbox1 && checkbox2 && checkbox3 && submitButton) {
      function updateButtonState() {
        submitButton.disabled = !(checkbox1.checked && checkbox2.checked && checkbox3.checked);
      }

      // Attach listeners
      checkbox1.addEventListener('change', updateButtonState);
      checkbox2.addEventListener('change', updateButtonState);
      checkbox3.addEventListener('change', updateButtonState);

      // Initial state on load
      updateButtonState();

      // Prevent submit if any checkbox is missing or unchecked
      submitButton.addEventListener('click', function (event) {
        if (!(checkbox1.checked && checkbox2.checked && checkbox3.checked)) {
          event.preventDefault();
        }
      });
    }
  });

  // Register page: require single agreement checkbox to enable submit button
  document.addEventListener('DOMContentLoaded', function () {
    const agreementCheckbox = document.getElementById('agreementCheckbox');
    const submitButton = document.getElementById('submitButton');

    // Only run register logic if we have the single checkbox and we're on register page
    if (agreementCheckbox && submitButton && document.querySelector('form[name="create"]')) {
    

      function updateRegisterButtonState() {
        const isChecked = agreementCheckbox.checked;
        submitButton.disabled = !isChecked;
        
      }

      // Attach listener to checkbox
      agreementCheckbox.addEventListener('change', updateRegisterButtonState);

      // Initial state on load
      updateRegisterButtonState();

      // Prevent submit if checkbox is not checked
      submitButton.addEventListener('click', function (event) {
        if (!agreementCheckbox.checked) {
          event.preventDefault();
          return false;
        }
      
      });


    }
  });

  // If cart has items, cart icon navigates to /cart instead of opening mini-cart
  document.addEventListener(
    "click",
    function (event) {
      const cartToggle = event.target.closest(
        '[data-action="toggle-mini-cart"]'
      );

      if (!cartToggle) return;

      const countElement = document.querySelector(".header__cart-count");
      const itemCount = countElement
        ? parseInt(countElement.textContent.trim(), 10) || 0
        : (window.theme && window.theme.cartCount) || 0;

      if (itemCount > 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.href =
          (window.routes && window.routes.cartUrl) || "/cart";
      }
    },
    true
  );

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
